import ToolTip from "@stadium/ui/src/components/tooltip/tooltip";

import styles from "./main.module.scss";

const GlobalRedemptionInfoTip = ({
  isGlobalZoneSelected,
  iconInfoClass,
  learnMoreClass,
  toolTipWrapperClass,
}) =>
  isGlobalZoneSelected && (
    <ToolTip
      content={
        <span style={{ whiteSpace: "pre-wrap", wordWrap: "break-word", fontWeight: "normal" }}>
          Global items will be available for any recipient whose country was not specified as part
          of this order. E.g.{" "}
          <span className={styles.egText}>
            If you have created an order with items for US and global recipients, only users outside
            of the US will be able to redeem the global items.
          </span>
        </span>
      }
      placement="top-start"
      isLightTheme
      arrow
      showCloseButton={true}
      asResponsiveModal
      contentContainerClass={styles.tippyContent}
      containerClass={`${styles.toolTipWrapper} ${toolTipWrapperClass}`}
      heading={<span className={styles.tooltipModalLabel}>Global Redemption</span>}
    >
      <span className={`${styles.iconInfo} ${iconInfoClass}`} />
      <span className={`${styles.learnMore} ${learnMoreClass}`}>Learn More</span>
    </ToolTip>
  );

export default GlobalRedemptionInfoTip;
